import { LineOfBusiness } from '../interfaces/LineOfBusiness';
import { LineOfBusinessDto } from '../interfaces/dtos/ContactUsDto';
import transformContact from './transformContact';

export default function transformLineOfBusiness(dto: LineOfBusinessDto): LineOfBusiness {
  return {
    name: dto.name,
    contacts: dto?.contacts?.map((c) => transformContact(c)) ?? undefined,
  };
}
